<template>
    <div v-if="loading" class="loader-units-table">
        <ui-load-indicator :h="58" :stroke="8" bg-color="#DFE5EC" color="#69D296" />
    </div>

    <template-list
        v-else
        :has-add-button="false"
        :header="false"
        :page-name="product ? product.name : 'Empreendimento'"
        :slot-page-list="$route.name === 'products.units'"
        :filters-apply-event="filtersApplyEvent"
        :search-input-placeholder="searchInputPlaceholder"
        title-top="Lista de Unidades"
        search-title="Filtrar Unidades"
        clear-filters-event="products-units-clean-filters"
        search-event="products-units-search"
        menu-card-icon="fal fa-cog"
        bg-row1="#FFF"
        search-input-label="Buscar:"
        placeholder-color-search-box="#8492AB"
        bg-color-search-box="#FFF"
    >
        <template #filters>
            <form>
                <template v-for="(filter, index) in filtersComputed">
                    <ui-select-v2
                        :key="index"
                        v-model="filter.params.value"
                        :data="filter.options"
                        :label="filter.label"
                        :item-label="filter.itemLabel"
                        :search="filter.searchAble"
                        :multiple="filter.multiple"
                        :return-value="filter.returnValue || 'object'"
                        :group-by="filter.groupBy || ''"
                        :loading="filter.loading"
                        :open-event="filter.openEvent"
                        :disabled="filter.disabled"
                        :show-apply-button="false"
                        size="md"
                        @input="call(filter.handler, $event)"
                    />
                </template>
            </form>
        </template>

        <template #actions>
            <div class="container-header">
                <div class="container-card">
                    <ui-product-result-card
                        v-for="(situation, index) in situationsComputed"
                        :key="index"
                        :data="situation"
                    />
                </div>
            </div>
        </template>

        <template #content>
            <div v-show="!loading" class="content-body">
                <section class="see-also">
                    <div class="expected-estimate-revenue-earns">
                        <div class="expected-estimate">
                            Receita Esperada:
                            <div class="expected-estimate-value">
                                <span>{{ summary.expected_revenue | currencyBRL }}</span>
                            </div>
                        </div>

                        <div class="revenue-earns">
                            Receita Ganha:
                            <div class="revenue-earns-value">
                                <span>{{ summary.revenue_earned | currencyBRL }}</span>
                            </div>
                        </div>
                    </div>
                </section>

                <div class="content-table">
                    <ui-table
                        :columns="tableColumns"
                        :sort-by="tableParams.sortBy"
                        :data="tableData"
                        :loading="loading"
                        name="erp-product-units"
                        tr-component="products/units/table-line"
                        not-found-text="Não foi possível encontrar nenhuma unidade"
                        not-found-icon="fal fa-building"
                        @load="loadData"
                        @sort="loadData"
                    />

                    <section class="ui-pagination" :class="{'show-filters-active': showFiltersActive}">
                        <div class="pagination-end">
                            <div v-if="pagination.total_pages > 1" class="text">
                                Página {{ pagination.page }} de {{ pagination.total_pages }}
                            </div>

                            <div v-if="pagination.total_pages > 1" class="control">
                                <button
                                    :disabled="!(pagination.total_pages > 1)"
                                    type="button"
                                    class="md"
                                    @click="previousPageHandler">
                                    <i class="fal fa-angle-left" />
                                </button>

                                <div class="control-list">
                                    <button
                                        v-for="(page, index) in paginationList"
                                        :key="index"
                                        :class="{ 'active': isActivePage(page.value) }"
                                        class="md"
                                        type="button"
                                        @click="listPageHandler(page.value)">
                                        {{ page.label }}
                                    </button>
                                </div>

                                <button
                                    :disabled="!(pagination.total_pages > 1)"
                                    type="button"
                                    class="md"
                                    @click="nextPageHandler">
                                    <i class="fal fa-angle-right" />
                                </button>
                            </div>
                        </div>
                    </section>
                </div>
            </div>

        </template>
    </template-list>
</template>

<script>
	import { uiLoadIndicator, uiTable } from '@/components/ui'
import uiProductResultCard from '@/components/ui-facilita/products/product-result-card'
import { uiSelectV2 } from '@/components/ui/form'
import templateList from '@/templates/page-list'

    import { currencyBRL } from '@/filters'
import { availability, product } from '@/services/axios'

	import { defaultTableColumns, filters } from './data'

    import { mapActions, mapGetters } from 'vuex'

	export default {
		name: 'ui-product-units-list',

		components: {
			templateList,
			uiTable,
            uiSelectV2,
            uiProductResultCard,
            uiLoadIndicator
		},

        filters: { currencyBRL },

		props: {
            /**
             * ID do produto cujas unidades estão sendo listadas
             */
			id: {
				type: [String, Number],
				required: true,
				default: 0
			}
		},

		data() {
			return {
                showFiltersActive: false,
                summary: {
                    situations: [],
                    expected_revenue: 0,
                    revenue_earned: 0
                },
				tableData: [],
				pagination: {
					total_pages: 0,
					list_size: 5,
					list_index: 0,
					per_page: 25,
					page: 1,
					search: '',
                    total: 0
				},
                search: {
                    q: ''
                },
                filters: [...filters],
				loading: false,
                syncValue: null
			}
		},

        computed: {
            ...mapGetters({
                tableParams: 'table/getParams',
                product: 'product/getProduct',
				revenue: 'product/getRevenue'
            }),
            /**
             * Computed property que filtra as situações de modo a mostrar apenas as situações que
             * possuírem unidades quando estas não forem dos tipos default (available, reserved e sale)
             */
            situationsComputed() {
                return this.summary.situations.filter(situation => {
                    let include = true
                    if (['pre-reserve', 'reserved-permanetly', 'unavailable'].includes(situation.name)) {
                        include = !!situation.total
                    }

                    return include
                })
            },
            /**
             * Computed property que filtra os itens de filtro desabilitados
             */
            filtersComputed() {
                return this.filters.filter(item => !item.hidden)
            },
			/**
             * Computed property que retorna uma lista de páginas disponíveis para navegação,
             * bem como opções para avançar ou regredir a lista
             */
            paginationList() {
                let list = [...Array(this.pagination.list_size).keys()].map(i => {
                    const page = (i + 1) + this.pagination.list_index * this.pagination.list_size

                    return { label: page, value: page }
                })
                list = list.filter(item => item.value <= this.pagination.total_pages)

                if (this.pagination.list_index) list.splice(0, 0, { label: '...', value: 'left' })
                if (list[list.length - 1].value < this.pagination.total_pages) {
                    list.splice(list.length, 0, { label: '...', value: 'right' })
                }

                return list
            },
            /**
             * Computed property que define as colunas da tabela, formatadas de acordo com o tipo
             * da disponibilidade do produto
             */
            tableColumns() {
                return this.product?.availability
                    ? Object.values(defaultTableColumns)
                        .filter(column => {
                            return !(this.product.availability.type === 'horizontal' && column.data === 'floor')
                        })
                        .map(column => {
                            // Verifica se a configuração de ocultar multi-propriedade está inativada
                            if (['block', 'number'].includes(column.data) &&
                                this.product?.infos?.multiProperty?.hideNumberAndBlock) {
                                column.title = ''

                            } else if (column.data === 'block') {
                                column.title = this.product.availability.type === 'horizontal'
                                    ? 'Quadra'
                                    : 'Torre'

                            } else if (column.data === 'number') {
                                column.title = this.product.availability.type === 'horizontal'
                                    ? 'Lote'
                                    : 'Unidade'
                            }

                            return column
                        })
                    : [...defaultTableColumns]
            },
            /**
             * Computed property que define dinamicamente o nome do evento a ser utilizado para
             * identificar que os filtros da listagem devem ser aplicados
             */
            filtersApplyEvent() {
                return `products-units-filters-apply-${this.id}`
            },
            /**
             * Computed property que retorna o placeholder do input de busca, de acordo com o tipo
             * de disponibilidade do empreendimento
             */
            searchInputPlaceholder() {
                return this.product?.availability?.type === 'horizontal'
                    ? 'Buscar por Quadra/Lote'
                    : 'Buscar por Torre/Unidade'
            }
        },

		mounted() {
            this.$root.$on('show-filters-active', payload => {
                this.showFiltersActive = payload
            })

            this.$root.$on('products-units-search', payload => {
                this.search.q = payload
                this.pagination.page = 1
                this.loadData()
            })

            this.$root.$on(this.filtersApplyEvent, () => {
                this.pagination.page = 1
                this.loadData()
            })

            // Caso uma reserva foi realizada, atualiza a lista de unidades
            /**
             * Obs.: Quando implementar o cadastro de reservas, verificar se pode remover
             * a emissão do evento de modal-close no beforeDestroy do modal de reservas
             * Porque senão, a lista será carregada toda vez que sair da página.
             */
            this.$root.$on('modal-close-global--request-reserve', ()=> {
                // this.loadData()
            })

            this.$root.$on('select-v2-open-event-units-list-blocks', () => {
                const filter = this.filters.find(item => item.params.name == 'blocks')
                this.loadFilter(filter)
            })

            this.$root.$on('select-v2-open-event-units-list-stages', () => {
                const filter = this.filters.find(item => item.params.name == 'stages')

                this.loadFilter(filter)
            })

            // Trata o evento que limpa os filtros e refaz a listagem
			this.$root.$on('products-units-clean-filters', async() => {
				await this.resetFilters()
				this.pagination.page = 1
				this.loadData()
			})

			this.loadData()

			/**
			* Seta o valor da receita, visto que ao trocar para imagem de implatanção ou
			* espelho digital está sobrescrevendo o valor de product na store e perdendo o valor da receita
			*/
			if(this.revenue.expected >= 0 && this.revenue.earned >= 0){
				this.summary.expected_revenue = this.revenue.expected
				this.summary.revenue_earned = this.revenue.earned
			}
		},

        beforeDestroy() {
            this.$root.$off('products-units-search')
            this.$root.$off(this.filtersApplyEvent)
            this.$root.$off('modal-close-global--request-reserve')
            this.$root.$off('select-v2-open-event-units-list-blocks')
            this.$root.$off('select-v2-open-event-units-list-stages')
            this.$root.$off('products-units-clean-filters')
            this.resetFilters()
        },

		methods: {
            ...mapActions('product', ['setProduct', 'setRevenue']),
            ...mapActions('detailsHasPermissions', ['updateDetails']),
            /**
			 * Chama dinamicamente um handler para tratar o evento do filtro
			 */
			call(handler, event) {
				if (handler) this[handler](event)
			},
            /**
			 * Seta as configurações necessárias para os filtros
			 */
			setFiltersConfigs() {
                if (this.product) {
                    for (const filter of this.filters) {
                        switch (filter.params.name) {
                            case 'blocks':
                                filter.serviceParams.push(this.product.availability_id)
                                break
                        }
                    }
                }
			},
            /**
             * Carrega os dados de um determinado filtro para serem selecionados
             */
            loadFilter(filter) {
                if (!this.product || filter.requestOnStart || filter.alreadyRequested) return

                if (filter.service) {
                    /**
                     * Para os empreendimentos de integração V2, as opções de filtro por quadra/torre são
                     * definidas pela requisição que carrega os dados do produto
                     */
                    if (filter.params.name === 'blocks' &&
                        this.product?.availability?.integration_erp?.version === 'v2') {
                        const label = this.product?.availability?.type === 'horizontal'
                            ? 'Quadra'
                            : 'Torre'

                        filter.options = this.product?.filters?.blocks
                            ? Object.values(this.product.filters.blocks).map(block => {
                                return { label: `${label} ${block}`, value: block }
                            })
                            : []

                    } else {
                        (() => import('@/services/axios/modules/'+ filter.service + '.js'))()
                            .then(service => {
                                const api = service.default.build()
                                let params = ['']
                                if (filter.serviceParams) params = [...filter.serviceParams]
                                filter.loading = true

                                api[filter.method](...params).then(response => {
                                    let data = []
                                    /** Verifica se a requisição retornou uma paginação */
                                    if (Object.prototype.hasOwnProperty.call(response.data, 'total')) {
                                        data = [...response.data.data]

                                    /** Verifica se a requisição retornou um array */
                                    } else if (Object.prototype.hasOwnProperty.call(response.data, 'length')) {
                                        data = [...response.data]

                                    /** Se nenhum dos outros casos for atendido, trata o retorno como um objeto */
                                    } else if (typeof response.data === 'object') {
                                        if (response.data.data) {
                                            data = Object.prototype.hasOwnProperty.call(response.data.data, 'length')
                                                ? [...response.data.data]
                                                : { ...response.data.data }

                                        } else {
                                            data = { ...response.data }
                                        }
                                    }

                                    /** Verifica se os resultados necessitam ser formatados */
                                    if (filter.parse) {
                                        const availabilityType = this.product.availability && this.product.availability.type
                                        filter.options = filter.parse(data, availabilityType)

                                    } else {
                                        filter.options = Object.values(data)
                                    }

                                    filter.alreadyRequested = true
                                })
                                .catch(error => {
                                    if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                                })
                                .finally(() => {
                                    filter.loading = false
                                })
                            })
                            .catch(error => {
                                console.error(error)
                            })
                    }
                } else if (filter.params.name === 'stages') {
                    /**
                     * Para o filtro de etapas, é necessário utilizar as opções retornadas pela
                     * requisição do produto
                     */
                    filter.options = Object.values(this.product?.filters?.stages || [])
                        .filter(stage => stage)
                        .map(stage => {
                            return { label: `Etapa ${stage}`, value: stage }
                        })
                    filter.alreadyRequested = true
                }
            },
            /**
             * Carrega as unidades do produto
             */
			loadData() {
				this.syncValue = this.$route.query.sync

                if (!this.id) {
                    this.$toastr.e('ID do produto inválido!')
                    this.$router.push({ name: 'products.list' })
                    return
                }

                this.tableData = []
                this.loading = true
                let filters = {
                    orderby: this.tableParams.sortBy.value,
                    order: this.tableParams.sortBy.dir,
					page: this.pagination.page,
					per_page: this.pagination.per_page,
				}

                // Processa os filtros, de modo a enviá-los como parâmetros na listagem
				for (const filter of this.filters) {
					if (filter.params.value) {
						const value = filter.params.value
						/**
						 * Caso o valor do filtro seja um array, converte este em uma String
						 * antes de atribuir aos parâmetros de busca
						 */
                        if (value &&
                            typeof value === 'object' &&
                            Object.prototype.hasOwnProperty.call(value, 'length')) {
                            filters[filter.params.name] = value.join(',') || ''

                        } else {
                            filters[filter.params.name] = value
                        }

					} else {
						continue
					}
				}

                // Verifica se há uma busca por Quadra/Lote
                if (this.search.q) {
                    const values = this.search.q.split('/')
                    if (values.length !== 2) {
                        this.$toastr.e('String de busca inválida! Esta deve ser no formato Quadra/Lote.')
                        this.loading = false
                        return
                    }
                    // Substitui o filtro de quadras/torres
                    filters.blocks = [values[0]]
                    // Seta o filtro de unidade/lote
                    filters.units = [values[1]]
                }

                /*
                 * Formata a URL de modo a enviar os parâmetros de busca no padrão QueryString requerido
                 * pela API V2
                 */
                let filter = ''
                for (const param in filters) {
                    let value = filters[param]
                    if (!value) continue

                    // Verifica se o parâmetro é um array
                    if (typeof value === 'object' &&
                        Object.prototype.hasOwnProperty.call(value, 'length')) {
                        value = value.join(',')
                    }
                    filter += `${param}:${value},`
                }

                const params = {
                    header: !this.product || (this.product.id !== parseInt(this.id)),
                    visualization: 'listunits',
                    filter,
                    sync: this.syncValue
                }

				product.getV2(this.id, 'units', params)
					.then(response => {
                        if (!response.data.data) {
                            this.$toastr.e('Este empreendimento não possui uma disponibilidade válida!')
                            this.$router.push({ name: 'products.list' })
                            return
                        }

                        if (response.data?.data?.availability?.units) {
                            const data = { ...response.data.data }
                            this.tableData = [...data.availability.units]
                            this.pagination.total = data.pagination.find
                            this.pagination.total_pages = Math.ceil(this.pagination.total / this.pagination.per_page)

                            /**
                             * Paga-se as informações retornadas quando o parâmetro header true é enviado.
                             * Para as demais requisições, não é possível pegar esta informação, por não ser
                             * retornado pela API
                             */
                            if (params.header) {
                                // Formata os status/situações das unidades a serem mostradas no resumo
                                this.summary.situations = Object.keys(data.situations).map(situation => {
                                    return (({
                                        name,
                                        color
                                    }) => ({
                                        label: name,
                                        color,
                                        name: situation,
                                        value: data.summary[situation] || 0,
                                        percent: data.summary.total
                                            ? parseFloat(
                                                ((data.summary[situation] || 0) / data.summary.total) * 100
                                            ).toFixed(2)
                                            : 0
                                    }))(data.situations[situation])
                                })
                                this.summary.expected_revenue = data.summary.expected_revenue || 0
                                this.summary.revenue_earned = data.summary.revenue_earned || 0

                                // Para empreendimentos integração V1, solicita o sincronismo das unidades
                                if (data?.availability?.integration_erp_id &&
                                    data.availability?.integration_erp.version !== 'v2') {
                                    availability.getBlocks(data.availability_id)
                                }

                                // Seta os dados do produto para serem utilizados pelo modal das unidades
                                this.setProduct(data)
								this.setRevenue({
									expected: this.summary.expected_revenue,
									earned: this.summary.revenue_earned
								})
                            }
                            // Seta o total de unidades encontradas para o empreendimento
                            this.$store.dispatch('dataTable/setTotal', this.pagination.total)
                            // Seta o ID da disponibilidade para os filtros de Etapa e Quadra/Torre
                            this.setFiltersConfigs()
                            /**
                             * Passa os dados para salvar os dados do filtro no localStorage
                             */
                            this.$root.$emit('set-filter-selected-active', this.filters.map(filter => {
                                return { ...filter.params }
                            }))
                        }
					})
					.catch(error => {
						if (error.data && error.data.msg && error.data.details.hasPermission !== false) this.$toastr.e(error.data.msg)
                        this.pagination.total = 0
                        this.pagination.total_pages = 0
                        this.pagination.page = 1

                        if (!error.data.msg) {
                            this.updateDetails(error.data.msg)
                            this.$router.push({ name: 'products.dataUnits' })
                        }

                        if (!error.data.details.hasPermission) {
                            this.updateDetails(error.data.details)
                            this.$router.push({ name: 'products.dataUnits' })
                        }
					})
                    .finally(() => {
                        this.loading = false
                    })
			},
            /**
             * Verifica se a página é aquela selecionada para paginação
             */
            isActivePage(page) {
                return this.pagination.page === page
            },
            /**
             * Event handler que trata o evento de quando uma página é selecionada diretamente
             * pela lista de páginas
             */
            listPageHandler(value) {
                switch (value) {
                    case 'right':
                        this.pagination.list_index++
                        break

                    case 'left':
                        this.pagination.list_index--
                        break

                    default:
                        this.setPage(value)
                        break
                }
            },
            /**
             * Seta a página a ser buscada e realiza a requisição
             */
            setPage(page) {
                if (page > 0 && page <= this.pagination.total_pages) {
					this.pagination.page = page
                    this.$set(this.pagination, 'page', page)

                } else if (page <= 0) {
					this.pagination.page = 1

                } else {
					this.pagination.page = this.pagination.total_pages
                }
                this.loadData()
            },
            /**
             * Event handler que trata o evento de quando a próxima página de unidades é requerida
             */
            nextPageHandler() {
                let page = this.pagination.page + 1
                this.setPage(page)
            },
            /**
             * Event handler que trata o evento de quando a página anterior de unidades é requerida
             */
            previousPageHandler() {
                let page = this.pagination.page - 1
                this.setPage(page)
            },
            /**
             * Event handler que trata o evento de quando o filtro de quadra/torre é setado
             */
            blockHandler() {
                const index = this.filters.findIndex(item => item.params.name == 'stages')
                this.filters[index].options = []
                this.filters[index].alreadyRequested = false
            },
			/**
			 * Reseta os filtros
			 */
			resetFilters() {
				for (const filter of this.filters) {
					if (filter.component === 'select-tags') {
						filter.params.value = null
						if (filter.handler) this.call(filter.handler, null)
					}
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>